export default "__VITE_ASSET__Cmdz8Cf3__"